import { apiClient } from '~/services/api-service';
import { CheckoutPriceResponse, CheckSubscriptionResponse, ConfigResponse } from '~/types/checkout';

export const checkoutAPIService = {
  getPrices: (currency: string) => {
    return apiClient.get<CheckoutPriceResponse>(`/checkout/price/?currency=${currency}`);
  },
  getConfig: () => {
    return apiClient.get<ConfigResponse>('/checkout/config/');
  },
  createPriceSession: (priceId: string, currency: string) => {
    return apiClient.get(`/checkout/create-checkout-session/${priceId}?currency=${currency}`);
  },
  checkSubscription: () => {
    return apiClient.get<CheckSubscriptionResponse>('/checkout/check-subscription/');
  },
  getCabinetLink: () => {
    return apiClient.get('/checkout/cabinet');
  },
  cancelSubscription: () => {
    return apiClient.get('/checkout/cabinet/cancel-subscription/');
  },
};
